module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/assessment_achievements/5@2x_de5238e9fb50f986b7e3023aeed66811.png";